import React, { useState } from "react";
import { Button, HiddenVisually, Text, Icon, Title, Link } from "@bookingcom/bui-react";
import { CloseIcon } from "@bookingcom/bui-assets-react/streamline";
import { useI18n, Trans } from "@bookingcom/lingojs-react";
import { t } from "@bookingcom/lingojs-core";
import SearchFiltersDisplayController from "../SearchFiltersDisplayController/index.js";
import Frame from "../Frame/index.js";
import { useGetAvailableFilters } from "../SearchResults/components/boundsFilterHooks.js";
import { getFiltersMeta } from "../../../constants/filtersMeta.js";
import { useFiltersReset } from "../../../hooks/useFiltersReset.js";
import { useAppliedFilters } from "../../../hooks/search/useAppliedFilters.js";
import flights_funnel_chip_sorting_desktop, { useTrackChipSortingDesktop } from "../../../utils/experiments/funnel/flights_funnel_chip_sorting_desktop.js";
import { useTrackLayoverPriceAirportFilterWeb } from "../../../utils/experiments/funnel/flights_funnel_layover_price_airport_filter_web.js";
export const FilterRow = ({ filterMeta, resetFilter }) => {
    const i18n = useI18n();
    const { copy, storeKeys } = filterMeta;
    if (!copy || !storeKeys)
        return null;
    return (React.createElement(Frame, { direction: "row", justifyContent: "space-between", alignItems: "center" },
        React.createElement(Text, { variant: "body_2" }, copy),
        React.createElement(Button, { variant: "light", onClick: () => {
                resetFilter(storeKeys);
            }, icon: React.createElement(Icon, { svg: CloseIcon, size: "small" }), attributes: {
                "aria-label": `${i18n.trans(t("flights_filter_reset"))} ${copy}`,
                "data-testid": `search_filters_summary_reset_filter_${storeKeys}`
            } })));
};
const SearchFiltersSummary = ({ isCompact, setDisplayedFiltersCountProp }) => {
    const SHOWN_FILTERS_COUNT_INITIAL = 3;
    const appliedFilters = useAppliedFilters();
    const i18n = useI18n();
    const filtersCount = appliedFilters.length;
    const [displayedFiltersCount, setDisplayedFiltersCount] = useState(SHOWN_FILTERS_COUNT_INITIAL);
    const { filteredTotalCount = 0 } = useGetAvailableFilters();
    const filtersMeta = getFiltersMeta(i18n);
    const { resetFilter, resetAllFilters } = useFiltersReset();
    useTrackChipSortingDesktop();
    const showMoreCopy = i18n.trans(t("flights_filters_show_more_action"));
    const showLessCopy = i18n.trans(t("flights_filters_show_less_action"));
    const trackLayoverPriceAirportFilterWeb = useTrackLayoverPriceAirportFilterWeb();
    return (React.createElement(React.Fragment, null,
        React.createElement(Frame, { mb: isCompact ? 0 : 4 },
            React.createElement(Frame, { direction: "row", justifyContent: "space-between" },
                React.createElement(Title, { title: i18n.trans(t("flights_filters_title")), variant: "strong_1", titleTagName: "h2" }),
                !isCompact && filtersCount > 0 && (React.createElement(Link, { onClick: resetAllFilters, attributes: { "data-testid": "search_filters_summary_reset_all" } },
                    React.createElement(Trans, { tag: "flights_filters_reset_all_action" })))),
            flights_funnel_chip_sorting_desktop.trackWithDefaultStage() ? (React.createElement(HiddenVisually, null,
                React.createElement("span", { "aria-live": "polite", "data-testid": "search_filters_summary_results_number" },
                    React.createElement(Trans, { tag: "flights_filters_num_results", variables: {
                            num_results: filteredTotalCount
                        }, num_exception: filteredTotalCount })))) : (React.createElement(Text, { variant: "body_2", color: "neutral_alt", attributes: { "data-testid": "search_filters_summary_results_number", "aria-live": "polite" } },
                React.createElement(Trans, { tag: "flights_filters_num_results", variables: {
                        num_results: filteredTotalCount
                    }, num_exception: filteredTotalCount })))),
        isCompact
            ? null
            : appliedFilters.slice(0, displayedFiltersCount).map((filter, index) => (React.createElement(Frame, { key: index, mb: 3 },
                React.createElement(FilterRow, { filterMeta: filtersMeta[filter], resetFilter: resetFilter })))),
        trackLayoverPriceAirportFilterWeb() ? undefined : (React.createElement(SearchFiltersDisplayController, { displayedRowsCount: displayedFiltersCount, setDisplayedRowsCount: isCompact && setDisplayedFiltersCountProp ? setDisplayedFiltersCountProp : setDisplayedFiltersCount, defaultDisplayedRowsCount: SHOWN_FILTERS_COUNT_INITIAL, allRowsCount: filtersCount, showMoreCopy: showMoreCopy, showLessCopy: showLessCopy }))));
};
export default SearchFiltersSummary;
